export default {
  projectTypes: {
    nature_based: "自然ベース / 土地利用（AFOLU）",
    energy_industry: "エネルギー・産業",
    waste_methane: "廃棄物・メタン",
    carbon_removal: "炭素除去・新技術",
    community_development: "コミュニティ・開発",
  },
  certifiers: {
    verra: "Verra",
    goldstandard: "Gold Standard",
    gcc: "GCC",
    tero: "Tero",
    planvivo: "Plan Vivo",
    arttrees: "ART TREES",
    socialcarbon: "Social Carbon",
    equitableearth: "Equitable Earth",
    isometric: "Isometric",
    puro: "Puro.earth",
  },
  methodologies: {
    afforestation_reforestation_ghg_emissions_reductions_sequestration_methodology:
      "植林・再植林によるGHG排出削減および炭素固定方法論",
    agroforestry: "アグロフォレストリー",
    ar_acm0003_afforestation_and_reforestation_of_lands:
      "AR-ACM0003 - 土地の植林および再植林",
    art_trees: "ART-TREES",
    art_trees_removals: "ART-TREES - 除去",
    biochar: "バイオ炭",
    biochar_production_and_storage: "バイオ炭の生産と貯留",
    biogenic_carbon_capture_and_storage: "生物由来炭素の回収と貯留",
    biomass_fermentation_with_carbon_capture_and_geologic_storage:
      "炭素回収・地中貯留を伴うバイオマス発酵",
    carbon_mineralisation_using_reactive_mineral_waste:
      "反応性鉱物廃棄物を用いた炭素鉱物化",
    carbonated_materials: "炭酸化材料",
    direct_air_capture_and_ocean_storage: "直接空気回収と海洋貯留",
    direct_ocean_capture_and_storage: "直接海洋回収と貯留",
    electrolytic_seawater_mineralization: "電解海水鉱物化",
    emission_reduction_by_shore_side_or_off_shore_electricity_supply_system:
      "陸上または洋上電力供給システムによる排出削減",
    emission_reductions_from_safe_drinking_water_supply:
      "安全な飲料水供給による排出削減",
    enhanced_rock_weathering: "強化岩石風化",
    gccm001_methodology_for_renewable_energy_generation_projects_supplying_electricity_to_grid_or_captive_consumers:
      "GCCM001 - 系統または自家消費者へ電力を供給する再生可能エネルギー発電プロジェクト方法論",
    gccm002_methodology_for_energy_saving_in_pumping_systems:
      "GCCM002 - ポンプシステムの省エネルギー方法論",
    gccm003_methodology_for_energy_generation_from_animal_manure_and_waste_management_projects:
      "GCCM003 - 家畜ふん尿および廃棄物管理プロジェクトからのエネルギー生成方法論",
    gccm004_methodology_for_water_grid_connected_renewable_energy_based_desalination_plant:
      "GCCM004 - 水道網接続型の再生可能エネルギー淡水化プラント方法論",
    gccm005_methodology_for_desalinated_water_savings_in_buildings:
      "GCCM005 - 建物における淡水化水の節水方法論",
    gccm006_energy_efficiency_measures_in_existing_centralized_cooling_systems:
      "GCCM006 - 既存集中冷房システムの省エネルギー対策",
    gccm007_methodology_for_private_carpooling_for_long_distance_inter_urban_travel:
      "GCCM007 - 都市間長距離移動における民間相乗り方法論",
    gccma001_gcc_nbs_methodology_for_forestry_project_activities_on_lands_except_wetlands:
      "GCCMA001 - 湿地を除く土地での森林プロジェクト活動向けGCC NBS方法論",
    gccma002_gcc_nbs_methodology_for_project_activities_on_degraded_mangrove_habitats:
      "GCCMA002 - 劣化したマングローブ生息地でのプロジェクト活動向けGCC NBS方法論",
    gccma003_gcc_nbs_methodology_for_rewetting_drained_peatlands:
      "GCCMA003 - 排水された泥炭地の再湿潤化向けGCC NBS方法論",
    gccmt001_methodology_for_project_activities_involving_the_capture_transport_and_geological_storage_of_carbon_dioxide:
      "GCCMT001 - 二酸化炭素の回収・輸送・地中貯留を伴う活動の方法論",
    geologically_stored_carbon: "地中貯留炭素",
    improved_forest_management: "改善森林管理",
    in_situ_capture_and_conversion_of_cattle_enteric_methane:
      "牛の腸内メタンの現場回収と変換",
    m001_terrestrial_forest_restoration: "M001 - 陸域森林再生",
    m002_terrestrial_forest_conservation: "M002 - 陸域森林保全",
    mangrove_restoration: "マングローブ再生",
    marine_anoxic_carbon_storage: "海洋無酸素炭素貯留",
    methane_emission_reduction_by_adjusted_water_management_practice_in_rice_cultivation:
      "稲作の水管理改善によるメタン排出削減",
    methane_emissions_reduction_from_enteric_fermentation_in_beef_cattle_through_application_of_feed_supplements_under_revision:
      "飼料添加物による肉牛の腸内発酵メタン排出削減（改訂中）",
    methodology_for_animal_manure_management_and_biogas_use_for_thermal_energy_generation:
      "家畜ふん尿管理と熱エネルギー生成向けバイオガス利用方法論",
    methodology_for_collection_of_sargassum_and_other_macroalgae_to_avoid_emissions_from_decomposition_and_to_use_for_beneficial_products:
      "分解由来排出を避け有益製品に利用するためのホンダワラ等大型藻類回収方法論",
    methodology_for_marine_fuels_and_biobunkers:
      "船舶燃料およびバイオバンカー方法論",
    methodology_for_metered_measured_energy_cooking_devices:
      "計量・測定型エネルギー調理機器方法論",
    methodology_for_reducing_methane_emissions_from_combustion_engine_exhaust:
      "燃焼エンジン排気からのメタン排出削減方法論",
    microalgae_carbon_fixation_and_sinking: "微細藻類による炭素固定と沈降",
    microbial_carbon_di_oxide_mineralisation: "微生物による二酸化炭素鉱物化",
    ocean_alkalinity_enhancement_from_coastal_outfalls:
      "沿岸放流水を用いた海洋アルカリ度向上",
    open_system_ex_situ_mineralization: "開放系の域外鉱物化",
    pm001_agriculture_forestry_carbon_benefit_assessment_methodology:
      "PM001 - 農業・森林炭素便益評価方法論",
    pm002_methodology_for_quantifying_carbon_benefits_from_small_scale_agroforestry:
      "PM002 - 小規模アグロフォレストリーの炭素便益定量化方法論",
    recovery_and_recycling_of_materials_from_solid_wastes:
      "固形廃棄物からの材料回収とリサイクル",
    reduced_emissions_from_cooking_and_heating_technologies_and_practices_to_displace_decentralised_thermal_energy_consumption_tpddtec:
      "分散型熱エネルギー消費を代替する調理・暖房技術と実践による排出削減（TPDDTEC）",
    reducing_methane_emissions_from_enteric_fermentation_in_dairy_cows_through_application_of_feed_supplements_under_revision:
      "飼料添加物による乳牛の腸内発酵メタン排出削減（改訂中）",
    reduction_in_methane_emissions_from_landfills_through_decentralised_organic_waste_processing:
      "分散型有機廃棄物処理による埋立地メタン排出削減",
    reforestation: "再植林",
    river_alkalinity_enhancement: "河川アルカリ度向上",
    scm0003_carbon_removal_in_private_conservation_areas:
      "SCM0003 - 民間保全地域における炭素除去",
    soil_organic_carbon_activity_module_biostimulants_for_soil_revitalisation:
      "土壌有機炭素活動モジュール - 土壌再生用バイオスティミュラント",
    soil_organic_carbon_activity_module_for_application_of_organic_soil_improvers_from_pulp_and_paper_mill_sludges:
      "パルプ・製紙汚泥由来有機土壌改良材の適用向け土壌有機炭素活動モジュール",
    soil_organic_carbon_activity_module_for_cover_crops:
      "被覆作物向け土壌有機炭素活動モジュール",
    soil_organic_carbon_activity_module_for_enhancing_carbon_stocks_in_managed_pasture:
      "管理牧草地の炭素ストック増加向け土壌有機炭素活動モジュール",
    soil_organic_carbon_activity_module_for_zero_tillage:
      "不耕起向け土壌有機炭素活動モジュール",
    soil_organic_carbon_activity_module_increasing_soil_carbon_through_improved_tillage_practices:
      "土壌有機炭素活動モジュール：改良耕起による土壌炭素増加",
    soil_organic_carbon_framework_methodology: "土壌有機炭素フレームワーク方法論",
    subsurface_biomass_carbon_removal_and_storage:
      "地下バイオマス炭素除去と貯留",
    suppressed_demand_methodology_micro_scale_electrification_and_energization_under_revision:
      "抑制需要方法論：マイクロ規模の電化・エネルギー供給（改訂中）",
    suppressed_demand_small_scale_methodology_for_energy_use_for_the_processing_of_agricultural_products_under_revision:
      "抑制需要小規模方法論：農産物加工のエネルギー利用（改訂中）",
    suppressed_demand_small_scale_methodology_for_low_ghg_food_preservation_under_revision:
      "抑制需要小規模方法論：低GHG食品保存（改訂中）",
    tero_001_redd: "TERO.001 - REDD+",
    tero_002_apd_avoided_planned_deforestation:
      "TERO.002 - APD（計画的森林減少の回避）",
    tero_003_carbon_stock_in_forests: "TERO.003 - 森林の炭素ストック",
    tero_004_carbon_removal_in_agricultural_crops:
      "TERO.004 - 農作物における炭素除去",
    tero_005_reduction_of_ghg_emissions_via_electric_vehicles:
      "TERO.005 - 電気自動車によるGHG排出削減",
    tero_006_arr_afforestation_reforestation_and_revegetation:
      "TERO.006 - ARR（植林、再植林、再植生）",
    tero_007_agricultural_land_management_alm:
      "TERO.007 - 農地管理（ALM）",
    terrestrial_storage_of_biomass: "陸域バイオマス貯留",
    the_gold_standard_simplified_methodology_for_clean_and_efficient_cookstoves:
      "クリーンで効率的な調理器具のGold Standard簡易方法論",
    two_and_three_wheeled_personal_transportation: "二輪・三輪個人交通",
    vm0001_refrigerant_leak_detection: "VM0001 - 冷媒漏えい検知",
    vm0003_improved_forest_management_through_extension_of_rotation_age:
      "VM0003 - 伐期延長による改善森林管理",
    vm0005_conversion_of_low_productive_forest_to_high_productive_forest:
      "VM0005 - 低生産性森林から高生産性森林への転換",
    vm0006_carbon_accounting_for_mosaic_and_landscape_scale_redd_projects:
      "VM0006 - モザイク・景観規模REDDプロジェクトの炭素会計",
    vm0007_redd_methodology_framework: "VM0007 - REDD+方法論フレームワーク",
    vm0008_weatherization_of_single_family_and_multi_family_buildings:
      "VM0008 - 戸建て・集合住宅の断熱改修",
    vm0010_improved_forest_management_conversion_from_logged_to_protected_forest:
      "VM0010 - 改善森林管理：伐採林から保護林への転換",
    vm0011_preventing_planned_degradation: "VM0011 - 計画的劣化の防止",
    vm0015_avoided_unplanned_deforestation:
      "VM0015 - 非計画的森林減少の回避",
    vm0016_recovery_and_destruction_of_ozone_depleting_substances_ods_from_products:
      "VM0016 - 製品由来のオゾン層破壊物質（ODS）の回収と破壊",
    vm0018_energy_efficiency_and_solid_waste_diversion_activities_within_a_sustainable_community:
      "VM0018 - 持続可能なコミュニティ内の省エネルギーと固形廃棄物転用活動",
    vm0019_fuel_switch_from_gasoline_to_ethanol_in_flex_fuel_vehicle_fleets:
      "VM0019 - フレックス燃料車両群でのガソリンからエタノールへの燃料転換",
    vm0025_campus_clean_energy_and_energy_efficiency:
      "VM0025 - キャンパスのクリーンエネルギーと省エネルギー",
    vm0032_adoption_of_sustainable_grasslands_through_adjustment_of_fire_and_grazing:
      "VM0032 - 火入れと放牧調整による持続可能な草地の導入",
    vm0033_tidal_wetland_and_seagrass_restoration:
      "VM0033 - 潮汐湿地と海草藻場の再生",
    vm0035_improved_forest_management_through_reduced_impact_logging:
      "VM0035 - 低影響伐採による改善森林管理",
    vm0038_electric_vehicle_charging_systems:
      "VM0038 - 電気自動車充電システム",
    vm0039_use_of_foam_stabilized_base_and_emulsion_asphalt_mixtures_in_pavement_application:
      "VM0039 - 舗装用途における発泡安定処理路盤と乳剤アスファルト混合物の使用",
    vm0041_reduction_of_enteric_methane_emissions_from_ruminants_through_the_use_of_feed_ingredients:
      "VM0041 - 飼料原料の使用による反芻動物の腸内メタン排出削減",
    vm0042_improved_agricultural_land_management: "VM0042 - 改善農地管理",
    vm0043_co2_utilization_in_concrete_production:
      "VM0043 - コンクリート生産におけるCO2利用",
    vm0044_biochar_utilization_in_soil_and_non_soil_applications:
      "VM0044 - 土壌および非土壌用途でのバイオ炭利用",
    vm0045_improved_forest_management_using_dynamic_matched_baselines_from_national_forest_inventories:
      "VM0045 - 国家森林インベントリ由来の動的マッチドベースラインを用いた改善森林管理",
    vm0046_reducing_food_loss_and_waste: "VM0046 - 食品ロスと廃棄の削減",
    vm0047_afforestation_reforestation_and_revegetation:
      "VM0047 - 植林、再植林、再植生",
    vm0048_vmd0055_reducing_emissions_from_unplanned_deforestation:
      "VM0048/VMD0055 - 非計画的森林減少からの排出削減",
    vm0049_carbon_capture_and_storage: "VM0049 - 炭素回収・貯留",
    vm0050_energy_efficiency_and_fuel_switch_measures_in_cookstoves:
      "VM0050 - 調理器具の省エネルギーと燃料転換",
    vm0051_improved_management_in_rice_production_systems:
      "VM0051 - 稲作生産システムの改善管理",
    vm0052_accelerated_retirement_of_coal_fired_power_plants_using_a_just_transition:
      "VM0052 - 公正な移行を用いた石炭火力発電所の早期退役",
    vmr0004_improved_efficiency_of_fleet_vehicles:
      "VMR0004 - 車両群の効率改善",
    vmr0007_recovery_and_recycling_of_materials_from_solid_wastes:
      "VMR0007 - 固形廃棄物からの材料回収とリサイクル",
    vmr0008_recovery_and_recycling_of_materials_from_e_waste:
      "VMR0008 - 電子廃棄物からの材料回収とリサイクル",
    vmr0009_avoided_emissions_from_biomass_wastes_through_use_as_feedstock_in_pulp_and_paper_cardboard_fiberboard_or_bio_oil_production:
      "VMR0009 - バイオマス廃棄物をパルプ、紙、段ボール、繊維板またはバイオオイル原料に利用することによる排出回避",
    vmr0010_electricity_supply_for_ships: "VMR0010 - 船舶への電力供給",
    vmr0012_production_of_geopolymer_cement:
      "VMR0012 - ジオポリマーセメントの生産",
    vmr0013_lightweight_two_and_three_wheeled_personal_transportation:
      "VMR0013 - 軽量二輪・三輪個人交通",
    vmr0014_electric_and_hybrid_vehicles_and_mobile_machinery:
      "VMR0014 - 電動・ハイブリッド車両および移動機械",
    vmr0015_low_greenhouse_gas_emitting_safe_drinking_water_production_systems:
      "VMR0015 - 低GHG排出型の安全な飲料水生産システム",
    vmr0016_flaring_or_use_of_landfill_gas:
      "VMR0016 - 埋立ガスのフレアまたは利用",
    wastewater_alkalinity_enhancement: "排水アルカリ度向上",
  },
};
